import { useState, useEffect } from 'react';
import { X, Save } from 'lucide-react';
import type { Job } from '../hooks/useWorkshop';

interface EditJobModalProps {
    job: Job | null;
    isOpen: boolean;
    onClose: () => void;
    onSave: (jobId: string, jobCreatedAt: string, updates: { job_description?: string; current_mileage?: number; estimated_completion?: string }) => Promise<void>;
}

export default function EditJobModal({ job, isOpen, onClose, onSave }: EditJobModalProps) {
    const [description, setDescription] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (job) {
            setDescription(job.vehicle_desc || ''); // Fallback setup...
        }
    }, [job]);

    if (!isOpen || !job) return null;

    const handleSave = async () => {
        setSaving(true);
        await onSave(job.id, job.created_at, {
            job_description: description,
            // current_mileage: parseInt(mileage) || undefined 
        });
        setSaving(false);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-scrim/50 backdrop-blur-sm p-4">
            <div className="bg-card border border-line rounded-xl w-full max-w-md shadow-2xl animate-in fade-in zoom-in duration-200">
                <div className="flex justify-between items-center p-4 border-b border-line">
                    <h2 className="text-lg font-bold text-fg">Edit Job Details</h2>
                    <button onClick={onClose} className="text-fg-3 hover:text-fg transition-colors">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-4 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-fg-3 mb-1">Vehicle</label>
                        <div className="text-fg font-mono bg-canvas px-3 py-2 rounded border border-line">
                            {job.vehicle_vrm} - {job.vehicle_desc}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-fg-3 mb-1">Job Description</label>
                        <textarea
                            className="w-full bg-canvas border border-line rounded-lg p-3 text-fg focus:outline-none focus:border-accent min-h-[100px]"
                            placeholder="Describe the work required..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </div>

                <div className="flex justify-end gap-3 p-4 border-t border-line bg-card/50 rounded-b-xl">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-fg-3 hover:text-fg transition-colors text-sm font-medium"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        className="flex items-center gap-2 fd-btn-primary px-4 py-2 rounded-lg font-bold transition-all disabled:opacity-50"
                    >
                        <Save className="w-4 h-4" />
                        {saving ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}
